import React from "react";

function ModelViewShtojca4({ tableContent }) {
  const getTotalPerMedia = (data) => {
    const totals = {};
    data.forEach((row) => {
      Object.entries(row).forEach(([key, value]) => {
        if (key !== "Protagonistët") {
          const num = parseFloat(value);
          totals[key] = (totals[key] || 0) + (isNaN(num) ? 0 : num);
        }
      });
    });
    return totals;
  };

  const formatNumber = (num) => num.toFixed(2);

  const tableStyle = {
    borderCollapse: "collapse",
    marginBottom: "40px",
    width: "100%",
  };

  const thStyle = {
    border: "1px solid #999",
    padding: "6px",
    backgroundColor: "#ed1d25",
    textAlign: "center",
    height: "100px",
    color: "white",
    fontWeight: "bold",
    fontSize: "14px",
  };

  const th2Style = {
    border: "1px solid #999",
    padding: "6px",
    backgroundColor: "rgb(217 217 217)",
    textAlign: "center",
    color: "black",
    fontWeight: "bold",
    fontSize: "14px",
  };

  const tdStyle = {
    border: "1px solid #999",
    padding: "6px",
    fontSize: "13px",
    textAlign: "right",
  };

  const temaStyle = {
    ...tdStyle,
    textAlign: "left",
    fontWeight: "bold",
  };

  const totals = getTotalPerMedia(tableContent);
  const mediaNames = Object.keys(totals);

  const firstTabelLables = ["RTSH 1", "KlanTv", "Top Channel", "Vizion Plus"];

  // Lista me pjesën tjetër
  const secondTableLabels = mediaNames.filter(
    (item) => !firstTabelLables.includes(item)
  );

  const mid = Math.ceil(mediaNames.length / 2);

  const renderTable = (medias) => (
    <table style={tableStyle}>
      <thead>
        <tr>
          <th style={thStyle}>Protagonistët / OSHMA</th>
          {medias.map((media) => (
            <React.Fragment key={media}>
              <th colSpan={2} style={thStyle}>
                {media}
              </th>
            </React.Fragment>
          ))}
        </tr>
      </thead>
      <thead>
        <tr>
          <th style={th2Style}></th>
          {medias.map((media) => (
            <React.Fragment key={media}>
              <th style={th2Style}>Min</th>
              <th style={th2Style}>%</th>
            </React.Fragment>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableContent.map((row, i) => (
          <tr key={i}>
            <td style={temaStyle}>{row["Protagonistët"]}</td>
            {medias.map((media) => {
              const minutes = parseFloat(row[media] || "0");
              const percent =
                totals[media] > 0 ? (minutes / totals[media]) * 100 : 0;
              return (
                <React.Fragment key={media}>
                  <td style={tdStyle}>{formatNumber(minutes)}</td>
                  <td style={tdStyle}>{formatNumber(percent)}%</td>
                </React.Fragment>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div>
      {renderTable(firstTabelLables)}
      {renderTable(secondTableLabels)}
    </div>
  );
}

export default ModelViewShtojca4;
